/**
 * Filtres custom — AJAX sans reload + état loading.
 */
(function () {
  'use strict';

  function sectionIdFrom(el) {
    var section = el && el.closest && el.closest('.shopify-section');
    if (!section || !section.id) return null;
    return section.id.replace('shopify-section-', '');
  }

  function setLoading(on) {
    document.querySelectorAll('[data-lgk-custom-filters]').forEach(function (root) {
      root.classList.toggle('is-loading', !!on);
    });
  }

  document.addEventListener('theme:loading:start', function () {
    setLoading(true);
  });
  document.addEventListener('theme:loading:end', function () {
    setLoading(false);
  });

  function ajaxNavigate(anchor) {
    if (!anchor || !anchor.href) return false;
    try {
      var url = new URL(anchor.href, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      if (document.body.classList.contains('template-search') && url.pathname.indexOf('/collections/') === 0) {
        return false;
      }
      // Pages hors collection → navigation normale
      if (url.pathname.indexOf('/pages/') === 0) return false;

      var sid = sectionIdFrom(anchor);
      if (!sid) return false;
      url.searchParams.set('section_id', sid);
      url.searchParams.delete('page');
      anchor.dispatchEvent(
        new CustomEvent('facet:update', {
          bubbles: true,
          detail: { url: url },
        })
      );
      return true;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var a =
        e.target.closest &&
        e.target.closest('.lgk-cf a.lgk-cf__chip, .lgk-cf a.lgk-cf__clear, .lgk-cf .lgk-facet-browse__chip');
      if (!a) return;
      if (a.closest('facet-link')) return;
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (ajaxNavigate(a)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Enter') return;
    var chip = e.target.closest && e.target.closest('.lgk-cf__chip');
    if (!chip) return;
    e.preventDefault();
    chip.click();
  });
})();
